export const YEARLY_CARD_IMAGE = `${process.env.REACT_APP_CLOUD_FRONT_URL}/gift/yearly.png`;
export const LIFETIME_CARD_IMAGE = `${process.env.REACT_APP_CLOUD_FRONT_URL}/gift/lifetime.png`;
